import { gql } from "@apollo/client"
import { InjectedOptions, useQuery } from "@oysterhr/core"
import { CompensationInsightsSalaryBenchmarksArgs, SalaryBenchmark } from "@oysterhr/schema"

export type SalaryBenchmarksQueryPayload = {
  compensationInsights: {
    salaryBenchmarks: SalaryBenchmark[]
  }
}

export const SALARY_BENCHMARKS_QUERY = gql`
  query SalaryBenchmarks(
    $providerIds: [ProvidersEnum!]!
    $roleTypeId: ID!
    $countryCode: CountryIsoCode!
    $seniorityLevel: EngagementSeniorityLevelType!
    $currencyCode: String
    $budgetAmount: Float
  ) {
    compensationInsights {
      salaryBenchmarks(
        providerIds: $providerIds
        roleTypeId: $roleTypeId
        countryCode: $countryCode
        seniorityLevel: $seniorityLevel
        currencyCode: $currencyCode
        budgetAmount: $budgetAmount
      ) {
        low {
          subunit
          currencyCode
        }
        mid {
          subunit
          currencyCode
        }
        high {
          subunit
          currencyCode
        }
        trustLevel
        providerId
        level
      }
    }
  }
`

export const useSalaryBenchmarksQuery = (
  options?: InjectedOptions<
    SalaryBenchmarksQueryPayload,
    CompensationInsightsSalaryBenchmarksArgs
  > & {
    skip?: boolean
    showErrorModal?: boolean
  },
) =>
  useQuery<SalaryBenchmarksQueryPayload, CompensationInsightsSalaryBenchmarksArgs>(
    SALARY_BENCHMARKS_QUERY,
    options,
  )
